/**
 * Merge CMS section data with fallback defaults.
 * Prefer CMS fields when present; keep fallback arrays/objects when CMS ones are empty.
 */
export function mergeCmsSection(cmsSection, fallback = {}) {
  if (!cmsSection || typeof cmsSection !== "object") {
    return JSON.parse(JSON.stringify(fallback || {}));
  }
  if (!fallback || typeof fallback !== "object") {
    return JSON.parse(JSON.stringify(cmsSection));
  }

  const out = { ...fallback, ...cmsSection };

  for (const key of Object.keys(fallback)) {
    const cmsVal = cmsSection[key];
    const fbVal = fallback[key];

    if (Array.isArray(fbVal)) {
      if (!Array.isArray(cmsVal) || cmsVal.length === 0) {
        out[key] = JSON.parse(JSON.stringify(fbVal));
      }
      continue;
    }

    if (fbVal && typeof fbVal === "object") {
      out[key] = mergeCmsSection(
        cmsVal && typeof cmsVal === "object" ? cmsVal : {},
        fbVal
      );
      continue;
    }

    if (cmsVal === undefined || cmsVal === null || cmsVal === "") {
      out[key] = fbVal;
    }
  }

  return out;
}
